import React, { useState, useEffect } from 'react';
import { Wrap } from './style';
import { useHistory } from 'troyfe';
import { Button, Form, Input, Row, Col, Select, DatePicker, message, Tag, Modal } from 'antd';
import { AnimationModal, Tables } from '@/components';

import {AdminUserOrganizeApi} from "gmrfid-service-user-api-manager"
import {AdminNewsApi} from "gmrfid-service-community-api-manager"

import moment from 'moment';
import defaultSettings from '@/defaultSettings';
import store from '@/store';
import { imgUrlHandle } from '@/utils';

const { Option } = Select;

const bodyStyle = {
  padding: '0px',
};

const index = () => {
  const history = useHistory();
  const [appState] = store.useModel('app');
  const { appConfig } = appState;
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [status, setStatus] = useState(0);
  const [data, setData] = useState([]);
  const [text, settext] = useState({});
  const [messageData, setMessageData] = useState({});
  const [limitTableTime, setLimitTableTime] = useState();
  const [fields, setFields] = useState({
    endTime: '',
    keyWords: '',
    startTime: '',
    status: '',
  });
  const columns = [
    {
      title: '序号',
      dataIndex: 'num',
      key: 'num',
    },
    {
      title: '标题',
      // dataIndex: 'title',
      width: 500,
      key: 'title',
      render: (text) => {
        return (
          <div style={{ display: 'flex' }}>
            {text.stick && (
              <Tag style={{ border: '1px solid #44BB55', backgroundColor: 'white', color: '#44BB55' }}>置顶</Tag>
            )}
            <div className="tableTitle">{text.title}</div>
          </div>
        );
      },
    },
    {
      title: '认证状态',
      // dataIndex: 'status',
      key: 'status',
      render: (text) =>
        text.status == 'YFB' ? (
          <a style={{ color: '#44BB55' }}>已发布</a>
        ) : text.status == 'DFB' ? (
          <a style={{ color: '#666666' }}>未发布</a>
        ) : (
          <a style={{ color: '#666666' }}>已撤稿</a>
        ),
    },
    {
      title: '发布时间',
      // dataIndex: 'time',
      key: 'time',
      render: (text) =>
        text.status == 'YFB' || text.status == 'YCX' ? (
          <a style={{ color: 'black' }}>{moment(text.putTime).format('YYYY-MM-DD HH:mm:ss')}</a>
        ) : (
          ''
        ),
    },
    {
      title: '操作',
      key: 'address',
      width: 400,
      render: (text) => {
        return (
          <div className="operation">
            <a
              onClick={() => {
                history.push(`/lookJournalism?${text.id}`);
              }}
            >
              查看
            </a>
            <a onClick={() => getLook(text)}>预览</a>
            {text.status === 'YFB' ? (
              text.stick ? (
                <a className="cancel" onClick={() => changeStick(text)}>
                  取消置顶
                </a>
              ) : (
                <a onClick={() => changeStick(text)}>置顶</a>
              )
            ) : (
              ''
            )}
            {text.status != 'YFB' ? (
              <a
                onClick={() => {
                  history.push(`/addJournalism?${text.id}`);
                }}
              >
                编辑
              </a>
            ) : (
              ''
            )}
            {text.status == 'YFB' ? (
              <a
                onClick={() => {
                  setVisible(true), setStatus(0), settext({ ...text });
                }}
              >
                撤稿
              </a>
            ) : (
              <a
                onClick={() => {
                  setVisible(true), setStatus(1), settext({ ...text });
                }}
              >
                发布
              </a>
            )}
            <a
              onClick={() => {
                setVisible(true), setStatus(2), settext({ ...text });
              }}
              className="del"
            >
              删除
            </a>
          </div>
        );
      },
    },
  ];

  //置顶或取消置顶
  const changeStick = (value) => {
    AdminNewsApi.updateStick({ form: { id: value.id, stick: !value.stick } }).then((res) => {
      setFields({ ...fields });
    });
  };

  //发布,撤稿或删除新闻
  const delFn = () => {
    if (status == 0 || status == 1) {
      AdminNewsApi.updateStatus({ form: { id: text.id, status: status ? 'YFB' : 'YCX' } }).then(
        (res) => {
          setFields({ ...fields });
        },
      );
    } else {
      AdminNewsApi.delete({ form: { id: text.id } }).then((res) => {
        setFields({ ...fields });
      });
    }
    setVisible(false);
  };

  //搜索
  const onFinish = (value) => {
    if (value.startTime || value.endTime) {
      value.endTime = value.endTime ? moment(value.endTime).format('YYYY-MM-DD') : null;
      value.startTime = value.startTime ? moment(value.startTime).format('YYYY-MM-DD') : null;
      console.log(value.endTime, value.startTime);
      if (value.startTime == value.endTime) {
        value.startTime = value.startTime + ' 00:00:00.000';
        value.endTime = value.endTime + ' 23:59:59.999';
      } else if (value.startTime == null) {
        value.endTime = value.endTime + ' 00:00:00.000';
      } else if (value.endTime == null) {
        value.startTime = value.startTime + ' 00:00:00.000';
      } else {
        value.startTime = value.startTime + ' 00:00:00.000';
        value.endTime = value.endTime + ' 00:00:00.000';
      }
    }
    setFields({ ...value });
  };

  //预览
  const getLook = (value) => {
    AdminNewsApi.detail({ form: { id: value.id } }).then((res) => {
      console.log(res.data);
      setMessageData(res.data);
    });
    setVisible1(true);
  };

  const tablesTemplateOption = {
    columns,
    pagination: false,
    fields,
    parameterName: 'param',
    tableTime: limitTableTime,
    queryTableList: AdminNewsApi.list,
    tableTree: true,
    customSize: 10,
    newPagination: true,
  };
  return (
    <Wrap>
      <div className="title">新闻资讯</div>
      <Form className="form" form={form} onFinish={onFinish}>
        <Row gutter={24}>
          <Col span={9}>
            <Form.Item label="关键字" name="keyWords">
              <Input size="large" allowClear placeholder="请输入标题" />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item label="状态" name="status">
              <Select placeholder="请选择状态" size="large">
                <Option value="YFB">已发布</Option>
                <Option value="DFB">未发布</Option>
                <Option value="YCX">已撤稿</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={9}>
            <Form.Item label="时间区间" style={{ marginBottom: 0, display: 'flex' }}>
              <Form.Item name="startTime" style={{ width: '50%' }}>
                <DatePicker placeholder="请选择" />
              </Form.Item>
              <span
                style={{
                  display: 'inline-block',
                  width: '1.5rem',
                  lineHeight: '3rem',
                  textAlign: 'center',
                }}
              >
                -
              </span>
              <Form.Item name="endTime" style={{ width: '50%' }}>
                <DatePicker placeholder="请选择" />
              </Form.Item>
            </Form.Item>
          </Col>
          <Col span={6} offset={8}>
            <div className="btnBox">
              <Button className="btn" htmlType="submit">
                搜索
              </Button>
              <Button
                className="btn"
                onClick={() => {
                  form.resetFields();
                  setFields({ endTime: '', keyWords: '', startTime: '', status: '' });
                }}
              >
                重置
              </Button>
              <Button className="btn" onClick={() => history.push('/addJournalism')}>
                新建
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
      <Tables {...tablesTemplateOption} />
      <Modal
        // title="预览"
        closable={false}
        visible={visible1}
        cancelText={false}
        bodyStyle={bodyStyle}
        getContainer={false}
        footer={null}
        onCancel={() => {
          setVisible1(false), setMessageData({});
        }}
        width={'34rem'}
      >
        <div className="right">
          <div className="header">
            <img src="/previousMonth.png" />
            <div>新闻详情</div>
          </div>
          <div className="title">{messageData.title}</div>
          <div className="time">
            {appConfig?.title}:{moment(messageData.putTime).format('YYYY-MM-DD HH:mm:ss')}
          </div>
          <div id="content" className="content">
            {messageData.contentType == 'TW' && <div dangerouslySetInnerHTML={{ __html: messageData.content }}></div>}
            {messageData.contentType == 'SP' && (
              <video controls="controls">
                <source src={imgUrlHandle(messageData.files[0])} />
              </video>
            )}
          </div>
        </div>
      </Modal>
      {visible && (
        <AnimationModal
          width={480}
          title={`${status == 0 ? '撤稿' : status == 1 ? '发布' : '删除'}新闻资讯`}
          isFooter
          closeCallback={() => {
            // setTableObj({});
            setVisible(false);
          }}
          confirmCallback={() => {
            delFn();
          }}
        >
          <h1>
            {status == 0 && '该操作不可撤销，请谨慎操作，确认撤稿该新闻资讯吗'}
            {status == 1 && '发布后，家园将显示该条新闻资讯'}
            {status == 2 && '该操作不可撤销，请谨慎操作，确认删除该新闻资讯'}
          </h1>
        </AnimationModal>
      )}
    </Wrap>
  );
};
export default index;
